export default {
    news: '新闻',
    raiders: '攻略',
    world_view: '世界观',
    ugc: '粉丝UGC',
    hot_news: '热门新闻',
    recommend: '推荐',
    download: '立即下载',
    empty_data: '没有更多数据了~~',
    more: '更多',
    detail: '详情',
    collapse: '隐藏',
    home_title: '社区',
    top: '置顶',

    team_simulator: '阵容模拟',
    simulator_hero: '点击“+”添加英雄和神器',
    active_synergy_title: '羁绊激活',
    simulator_synergy: '点亮下方羁绊图标，可激活羁绊',
    team_hero: '阵容英雄',
    actived_synergy: '已解锁英雄羁绊',
    checkall_synergy: '全部激活',
    synergy_effects: '英雄羁绊效果',
    tj_team: '推荐阵容',
    query_link: '查看详情',
    save_image: '保存图片',
    share_image: '分享阵容',
    artifact: '神器',
    base_synergy: '基础羁绊',
    faction_synergy: '阵营羁绊',
    rune_synergy: '符文羁绊',
    hero_detail: '阵容详情',
    add_hero: '添加你的英雄',
    add_artifact: '添加你的神器',

    relic_synergy_title: '神器羁绊',
    relic_effects: '神器羁绊效果',
    actived_relic_synergy: '已解锁神器羁绊',
    relic_kind: '类别'
}